import AboutUs from "../components/pages/AboutUs";

export default function AboutUsPage() {
  return <AboutUs />;
}